var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.354813 14.4819C0.733027 14.0797 1.3655 14.0599 1.7679 14.438L6.79524 19.1606L6.8177 19.1831C7.86249 20.2283 9.15491 20.9922 10.5745 21.4028C11.9943 21.8134 13.4954 21.8579 14.9368 21.5317C16.3783 21.2055 17.714 20.5193 18.8187 19.5376C19.9233 18.5557 20.7622 17.3098 21.2552 15.9165C21.4395 15.396 22.011 15.1229 22.5316 15.3071C23.0517 15.4916 23.324 16.0631 23.14 16.5835C22.5342 18.2953 21.5049 19.8264 20.1478 21.0327C18.7906 22.239 17.1492 23.0812 15.3783 23.4819C13.6072 23.8826 11.7632 23.8282 10.0189 23.3237C8.28461 22.8221 6.70488 21.8916 5.42513 20.6187L0.398758 15.895C-0.00369328 15.5168 -0.02337 14.8844 0.354813 14.4819ZM10.6214 2.51709C12.3924 2.11645 14.2366 2.17083 15.9808 2.67529C17.7151 3.17698 19.2948 4.1084 20.5745 5.38135L25.6019 10.104C26.0041 10.4821 26.0236 11.1156 25.6458 11.5181C25.2677 11.9205 24.6343 11.9401 24.2318 11.562L19.2054 6.83838C19.1979 6.83132 19.1902 6.82418 19.1829 6.81689C18.1381 5.77154 16.8449 5.00788 15.4251 4.59717C14.0054 4.18652 12.5043 4.14216 11.0628 4.46826C9.62136 4.79444 8.28566 5.48062 7.18098 6.4624C6.07632 7.44426 5.23852 8.69023 4.74544 10.0835C4.56126 10.604 3.98959 10.8768 3.46907 10.6929C2.9485 10.5087 2.67561 9.93709 2.8597 9.4165C3.46549 7.70469 4.49562 6.17361 5.85286 4.96729C7.21001 3.76121 8.85056 2.91779 10.6214 2.51709Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9167 4.33331V10.8333H18.4167",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9167 4.33331V10.8333H18.4167L24.9167 4.33331Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08334 21.6667V15.1667H7.58334",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08334 21.6667V15.1667H7.58334L1.08334 21.6667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncEvent);
export default __webpack_public_path__ + "static/media/SyncEvent.ddf494e3c465d292ac2ab869b99400d1.svg";
export { ForwardRef as ReactComponent };